import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=a5a98696&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a98696",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5a98696')) {
      api.createRecord('a5a98696', component.options)
    } else {
      api.reload('a5a98696', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=a5a98696&scoped=true&", function () {
      api.rerender('a5a98696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4hF4RzGF0ycu7/JS/comp/Voucher-Unit.vue"
export default component.exports